import React, { useRef, useState, useEffect } from "react";
import { Eraser } from "lucide-react";

/**
 * Canvas per firma mouse+touch. Restituisce PNG base64 via onChange(dataUrl).
 */
export default function SignaturePad({ onChange, width = 500, height = 180, disabled = false, dataTestid }) {
  const canvasRef = useRef(null);
  const drawing = useRef(false);
  const [hasInk, setHasInk] = useState(false);

  useEffect(() => {
    const c = canvasRef.current;
    if (!c) return;
    const ctx = c.getContext("2d");
    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, c.width, c.height);
    ctx.strokeStyle = "#0F2E4F";
    ctx.lineWidth = 2;
    ctx.lineCap = "round";
    ctx.lineJoin = "round";
  }, []);

  const pos = (e) => {
    const c = canvasRef.current;
    const rect = c.getBoundingClientRect();
    const clientX = e.touches ? e.touches[0].clientX : e.clientX;
    const clientY = e.touches ? e.touches[0].clientY : e.clientY;
    return { x: (clientX - rect.left) * (c.width / rect.width),
             y: (clientY - rect.top) * (c.height / rect.height) };
  };
  const start = (e) => {
    if (disabled) return;
    e.preventDefault();
    drawing.current = true;
    const { x, y } = pos(e);
    const ctx = canvasRef.current.getContext("2d");
    ctx.beginPath(); ctx.moveTo(x, y);
  };
  const move = (e) => {
    if (!drawing.current || disabled) return;
    e.preventDefault();
    const { x, y } = pos(e);
    const ctx = canvasRef.current.getContext("2d");
    ctx.lineTo(x, y); ctx.stroke();
    if (!hasInk) setHasInk(true);
  };
  const end = () => {
    if (disabled) return;
    drawing.current = false;
    if (hasInk && onChange) {
      const dataUrl = canvasRef.current.toDataURL("image/png");
      onChange(dataUrl);
    }
  };
  const clear = () => {
    const c = canvasRef.current;
    const ctx = c.getContext("2d");
    ctx.fillStyle = "#ffffff"; ctx.fillRect(0, 0, c.width, c.height);
    setHasInk(false);
    onChange && onChange(null);
  };

  return (
    <div className="w-full">
      <div className="border border-dashed border-slate-300 rounded-lg bg-white p-1 overflow-hidden">
        <canvas
          ref={canvasRef} width={width} height={height}
          data-testid={dataTestid || "signature-canvas"}
          className={`w-full rounded ${disabled ? "opacity-60" : ""}`}
          style={{ touchAction: "none" }}
          onMouseDown={start} onMouseMove={move} onMouseUp={end} onMouseLeave={end}
          onTouchStart={start} onTouchMove={move} onTouchEnd={end}
        />
      </div>
      <div className="flex items-center justify-between mt-1 text-[11px] text-slate-500">
        <span>{hasInk ? "Firma acquisita ✓" : "Firma qui sopra"}</span>
        <button type="button" onClick={clear} disabled={disabled || !hasInk}
                data-testid="signature-clear"
                className="flex items-center gap-1 hover:text-red-600 disabled:text-slate-300">
          <Eraser size={12} /> Cancella firma
        </button>
      </div>
    </div>
  );
}
